import { useState } from "react";
import "./StillEmailCapture.css";

function StillEmailCapture() {
  const [email, setEmail]     = useState("");
  const [status, setStatus]   = useState("idle"); // idle | loading | success | error
  const [touched, setTouched] = useState(false);

  const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!isValid) { setTouched(true); return; }

    setStatus("loading");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/mailinglist`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "Subscription failed");
      }
      setStatus("success");
    } catch {
      setStatus("error");
    }
  }

  return (
    <section className="sec-email" aria-label="Email sign-up">

      <div className="sec-email__inner">

        {status === "success" ? (
          <div className="sec-email__confirmed">
            <span className="sec-email__confirmed-mark">✦</span>
            <p className="sec-email__confirmed-head">You're in.</p>
            <p className="sec-email__confirmed-sub">
              Welcome to STILL. Expect early access, curated drops, and nothing more.
            </p>
          </div>
        ) : (
          <>
            <p className="sec-email__eyebrow">The inner circle</p>

            <h2 className="sec-email__heading">
              First to know.<br />First to choose.
            </h2>

            <p className="sec-email__sub">
              Early access to new arrivals and ₹200 off your first pair.
              <br />No noise. Unsubscribe any time.
            </p>

            <form
              className="sec-email__form"
              onSubmit={handleSubmit}
              noValidate
            >
              <div className="sec-email__field-wrap">
                <input
                  className={`sec-email__input${touched && !isValid ? " sec-email__input--err" : ""}`}
                  type="email"
                  placeholder="your@email.com"
                  value={email}
                  onChange={e => { setEmail(e.target.value); setTouched(false); }}
                  onBlur={() => setTouched(true)}
                  aria-label="Email address"
                  autoComplete="email"
                  disabled={status === "loading"}
                />
                <button
                  className="sec-email__btn"
                  type="submit"
                  disabled={status === "loading"}
                  aria-label="Subscribe"
                >
                  {status === "loading" ? (
                    <span className="sec-email__spinner" aria-hidden="true" />
                  ) : (
                    "Join"
                  )}
                </button>
              </div>

              {touched && !isValid && (
                <p className="sec-email__err-msg" role="alert">
                  Please enter a valid email address.
                </p>
              )}

              {status === "error" && (
                <p className="sec-email__err-msg" role="alert">
                  Something went wrong. Please try again.
                </p>
              )}
            </form>

            <p className="sec-email__privacy">
              Your details stay with us. No third-party sharing.
            </p>
          </>
        )}

      </div>
    </section>
  );
}

export default StillEmailCapture;
